import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'

import { Can } from '../../../_contexts/AbilitiesContext'

export default function TodaysTelehealthsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Telehealth Appointments Today.
        </h5>
        
        <div className='my-4'>
          When you have scheduled Telehealth appointments they will appear here.
        </div>

        <Can I="schedule" a="telehealth">
          <Button as={Link} to='/telehealth/schedule' variant='outline-primary' className="px-5">
            Schedule Telehealth
          </Button>
        </Can>

      </Card.Body>
    </Card>
  )
}
